module.exports = __webpack_public_path__ + "static/media/product_08.38f927f3.jpg";